import { connect } from 'react-redux';
import { compose } from 'redux';

import { stateCurrentName } from '@Selectors/StateCurrentSelectors';
import { withTabletBreakpoint } from '@Hooks/withBreakpoints/withBreakpoint';
import { isRMCLicense, activeResults, companyLogoUrl, isAnonymousUser } from '../HeaderComponentSelectors';
import { goToRouterState, goToResults, getRouterHref, goToTexel } from '../HeaderComponentActions';
import GeneralMenuItems from './GeneralMenuItems';

function mapStateToProps(state) {
  return {
    isRMCLicense: isRMCLicense(state),
    companyLogoUrl: companyLogoUrl(state),
    stateCurrentName: stateCurrentName(state),
    activeResults: activeResults(state),
    isAnonymousUser: isAnonymousUser(state),
  };
}

const mapDispatchToProps = {
  goToRouterState,
  goToResults,
  getRouterHref,
  goToTexel,
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withTabletBreakpoint())(GeneralMenuItems);
